/**
 * Points 页首屏共享 /a/ores/points 请求（page=1&status=all&size=10）
 * 供 my-points-v2、points-rank-v2、points-details-v2 复用，避免同页重复请求。
 */
(function (global) {
  if (global.PointsPageAPI) return;

  var bootstrapPromise = null;
  var BOOTSTRAP_URL = '/a/ores/points?page=1&status=all&size=10';

  global.PointsPageAPI = {
    fetchBootstrap: function () {
      if (!bootstrapPromise) {
        bootstrapPromise = fetch(BOOTSTRAP_URL, { credentials: 'same-origin' })
          .then(function (res) {
            return res.json();
          })
          .then(function (json) {
            return (json && json.data) || null;
          })
          .catch(function () {
            bootstrapPromise = null;
            return null;
          });
      }
      return bootstrapPromise;
    },
  };
})(window);
